<template>
  <div class="information" :class="$mq">
    <h3>{{ $t('informations.title') }}</h3>
    <div class="inline">
      <div class="info inline top">
        <div class="consumption">
          <h4>{{ $t('informations.consumptions') }}</h4>
          <table class="consumptions">
            <tr v-for="consumption in activeConsumptions" :key="consumption.meterType">
              <td>{{ $tc(consumption.meterType, elecMeterTypes.length)}}</td>
              <td>{{ consumption.value }} {{ $t('kwh') }}</td>
            </tr>
          </table>
        </div>
        <div class="data" v-if="$mq !== 'mobile'">
          <h4>{{ $t('informations.zipCode') }}</h4>
          <div class="small">{{ zipCode }} {{ city }}</div>
          <div v-if="consent">
            <h4>{{ $t('informations.contact') }}</h4>
            <div class="small">{{ firstName }} {{ lastName }} - {{ phone }}</div>
            <div class="small">{{ mail }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="legal container">
      <span class="link" :class="$mq" @click="showCondition = true">{{ $t('simulationConditionTitle') }}</span>
      <div v-if="$mq !== 'mobile' || showCondition" :class="$mq">
        <div @click="showCondition = false" class="close" v-if="$mq === 'mobile'">x</div>
        <p>{{ $t('simulationConditionText', {'0': today.date, '1': today.month } )}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      showCondition: false
    };
  },
  computed: {
    ...mapGetters("consumption", ["activeConsumptions", "elecMeterTypes"]),
    ...mapState("consumption", ["meterType"]),
    ...mapState("calculation", ["zipCode", "city"]),
    ...mapState("contact", [
      "consent",
      "firstName",
      "lastName",
      "phone",
      "mail"
    ]),
    today() {
      let today = {
        date: moment().format('DD/MM/YYYY').toString(),
        month: moment().format('MMM YYYY').toString()
      }
      return today;
    }
  },
  created() {
  }
};
</script>

<style lang="scss" scoped>
.information {
  margin-top: 40px;
  margin-bottom: 30px;

  &.mobile {
    margin-top: 20px;
    .info {
      width: 80%;
    }
  }

  .info {
    min-width: 40%;
    box-shadow: 5px 10px 10px #4d545a18;
    // border-top: 2px solid #fdcb47;
    border-radius: 30px;
    padding: 10px;
    background: #e7eef0;
    border: 1px solid #fdcb47;

    h4 {
      margin: 10px;
    }
  }

  .consumption,
  .data {
    flex: 1;
    .consumptions {
      text-align: left;
      font-size: 0.8rem;
      width: 100%;
      border: 0;
      border-collapse: collapse;

      tr {
        td {
          padding: 7px 10px;

          .myprice {
            text-align: right;
            border: 1px solid #eee;
            width: 60px;
          }
        }
      }
    }
  }

  .legal {
    margin-top: 50px;
    font-size: 0.7rem;

    .link.mobile {
      text-decoration: underline;
    }

    div {
      &.mobile {
        font-size: 0.9rem;
        margin: 0;
        padding: 20px;
        background: white;
        z-index: 9999;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        .close {
          float: right;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          box-shadow: 0 0 7px rgba(0, 0, 0, 0.5);
          background: black;
          border: 2px solid #fdcb47;
          color: #fdcb47;
          height: 25px;
          width: 25px;
          border-radius: 50%;
        }

        p {
          margin-top: 45px;
          min-width: 100%;
        }
      }
      font-size: 0.6rem;
      text-align: justify;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/Informations.vue